export class StoragePeriodTypeConstants {
    public static asDict(): { [key in StoragePeriodType]: string } {
        return {
            YEAR: 'Year',
            MONTH: 'Month',
            WEEK: 'Week',
            DAY: 'Day',
            WITHINDAY: 'Within-day'
        };
    }

    public static asLabelValueArray(): {
        value: StoragePeriodType;
        [label: string]: string;
    }[] {
        const asDict = this.asDict();
        return Object.keys(asDict).map<{
            value: StoragePeriodType;
            [label: string]: string;
        }>((key: StoragePeriodType) => ({
            value: key,
            label: asDict[key]
        }));
    }
}
